// Geo-related helper functions

import { Feature } from "geojson";
import { latLngBounds } from "leaflet";

export const getBounds = (f: Feature) => {
  // Note: right now only works for points (not very usefully) and linestrings
  const geometry = f.geometry;
  let points: [number, number][] = [];

  if (geometry.type === "Point") {
    points = [[geometry.coordinates[1], geometry.coordinates[0]]];
  } else if (geometry.type === "LineString") {
    points = geometry.coordinates.map((coord) => [coord[1], coord[0]]);
  }

  return latLngBounds(points);
};

export const geometryToLatLng = (f: Feature | null) => {
  if (!f || !["Point", "LineString"].includes(f.geometry.type)) return null;

  const bounds = getBounds(f);
  return bounds.getCenter();
};
